import { useEditCompanyProfile } from "@/api/app/profile/useEditCompanyProfile";
import { Button } from "@/components/ui/button";
import { handleFormErrors } from "@/lib/handleFormErrors";
import toast from "@/lib/toast";
import { CompanyProfileEdit } from "@/schema/app/profile/companyProfileEdit";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { mutate } from "swr";

const CompanyFormActionButtons = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { handleSubmit, setError } = useFormContext<CompanyProfileEdit>();

  const { trigger: editCompanyProfile, isMutating: isCompanyMutating } =
    useEditCompanyProfile({
      onSuccess: (data) => {
        toast.success(data.message);
        mutate("/app/profile");
        navigate("/app/profile");
      },
      onError: (error) => {
        handleFormErrors(error.errors, setError);
      },
    });

  const handleCancel = () => {
    navigate("/app/profile");
  };

  const handleSave = (data: CompanyProfileEdit) => {
    editCompanyProfile(data);
  };

  return (
    <div className="flex justify-end gap-4">
      <Button variant="outline" onClick={handleCancel}>
        {t("cancel")}
      </Button>
      <Button
        isLoading={isCompanyMutating}
        onClick={handleSubmit((data) => {
          toast.loading(t("save-loading"));
          handleSave(data);
        })}
      >
        {t("save")}
      </Button>
    </div>
  );
};

export default CompanyFormActionButtons;
